module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-11-3edbba007f5e0a5edd1a67c6c65cc280.jpg";